import React, { useState, useEffect } from 'react';
import { useForm, useFieldArray, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import NiceModal, { useModal, bootstrapDialog } from '@ebay/nice-modal-react';
import BootstrapModal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { instance } from '../axios';
import { useNavigate, useParams } from 'react-router-dom';
import { UiItemSelect, UiInput, UiButton, UiSelect, PageError, BgLoader, OverlayLoader } from '../ui';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from '../state.js';
import { MdOutlineDragHandle } from 'react-icons/md';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { arrayMoveImmutable as arrayMove } from 'array-move';
import { MdOutlineClose } from "react-icons/md";

import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';

const SortableContainer = sortableContainer(({ children }) => {
  return <div className="">{children}</div>;
});

const DragHandle = sortableHandle(() => (
  <span className="h2 pe-2 mb-0 text-secondary">
    <MdOutlineDragHandle />
  </span>
));

const SortableItem = sortableElement((value) => {
  return (
    <div className="d-flex pitable bg-white" style={{ minWidth: '700px' }} {...value} />
  );
});

const ItemGroup = NiceModal.create(({ id, type, action, bgColor, note = "", data }) => {
  const [input, setInput] = useState(note);
  const [state, setState] = useState({ count: 0 });
  const [loader, showLoader] = useState(false);
  const modal = useModal();
  const zstate = useStore((state) => state.categories);
  const mstate = useStore((state) => state.machines);
  const setZState = useStore((state) => state.setGroups);
  const schema = yup.object().shape({
    name: yup.string().nullable().required('Name is required'),



    items: yup.array().of(
      yup.object().shape({
        item: yup.mixed().nullable().required('Item is required'),

        qty: yup.string().nullable().matches(/^[0-9]+$/, "Enter qty").min(0, 'Negative value not allowed'),
        rate: yup.string().nullable().matches(/^[0-9.]+$/, "Enter rate").min(0, 'Negative value not allowed'),
        amount: yup.string().nullable().matches(/^[0-9.]+$/, "Enter amount").min(0, 'Negative value not allowed'),
        tax: yup.string().nullable().required('Tax is required'),

      }, []),
    ),



  }, []);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    unregister,
    getValues,
    resetField,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const fetchData = () => {
    instance
      .get("/get_item_group?id=" + id)
      .then(function (response) {
        setState(response.data)
        reset(response.data.group)

      })
      .catch(function (error) { })
      .then(function () { });
  }


  const onSubmitHandler = async (data) => {
    SaveVoucher(data);
  };

  const { fields, append, move, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const insertEntry = () => {
    append({ account: null, credit: null, debit: null, narration: null });
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    move(oldIndex, newIndex)
  };

  const SaveVoucher = (e) => {
    if (state.credit != state.debit) {
      toast('Credit and Debit must be same', { type: 'error' });
    } else {
      showLoader(true);
    }

    instance({
      method: 'post',
      url: '/update_item_group',
      data: e,
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        showLoader(false);
        if (response.data.status === 'error') {
          toast(response.data.msg, { type: 'error' });
        }
        if (response.data.status === 'success') {
          toast(response.data.msg, { type: 'success' });
          modal.resolve({ resolved: true });
          modal.hide();
        }
      })
      .catch(function (response) { });
  };

  useEffect(() => {
    fetchData();
    // setState({ ...state, items: [{ id: 1 }] })
  }, []);

  const entryWatch = watch('items', fields);

  const calcTotal = (index) => {
    const qty = getValues(`items.${index}.qty`);
    const price = getValues(`items.${index}.rate`);
    const taxRate = getValues(`items.${index}.tax`);
    const taxAmount = ((price * qty * taxRate) / 100);
    const amount = (price * qty) + taxAmount;
    setValue(`items.${index}.amount`, amount.toFixed(2));
    calcGrandTotal();
  };
  useEffect(() => {
    calcTotal();
  }, [entryWatch]);


  const calcGrandTotal = () => {
    const grandtotal = getValues('items').reduce((sum, field) => {
      return sum + (parseFloat(field.amount) || 0);
    }, 0);

   

    setState((prev) => ({ ...prev, grandtotal: grandtotal  }));
  }




  const handleHide = () => {
    modal.hide();
  };


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }

  return (
    <BootstrapModal size="lg" {...bootstrapDialog(modal)} onHide={() => handleHide()}>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>Item Group</BootstrapModal.Title>
      </BootstrapModal.Header>
      <OverlayLoader visible={loader} />
      {state.status ?
        <>
          <BootstrapModal.Body>



            <UiInput
              name={`name`}
              label="Group Name"
              required={true}
              {...register(`name`)}
              message={errors.name?.message}
            />
            <p className='fs-5 fw-bold'>Items</p>
            <div className='table-responsive'>
            <div className="d-flex pitable bg-white" style={{ minWidth: '700px' }} >
              <div className={`col1 border border-end-0 border-start-0`} style={{ width: '50px' }}>
              </div>
              <div className="col border border-end-0 p-1" style={{ minWidth: '200px' }}>
                Item

              </div>
              <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                Qty.
              </div>
              <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                Rate
              </div>
              <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                GST %
              </div>
              <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                Amount
              </div>


              <div className="col1 border border-end-0 text-center p-1" style={{ width: '35px' }}>
              </div>
            </div>

            <SortableContainer onSortEnd={onSortEnd} useDragHandle>
              {fields.map((val, i) => (
                <SortableItem key={i} index={i}>
                  <div className={`col1 border border-end-0 border-start-0 type_${val.type}`} style={{ width: '50px' }}>
                    <DragHandle />
                  </div>

                  <div className="col border border-end-0 p-1" style={{ minWidth: '200px' }}>
                    <Controller
                      key={`item-${val.id}`}
                      name={`items.${i}.item`}
                      control={control}

                      render={({ field }) => (

                        <UiItemSelect
                          {...field}
                          required={true}
                          parentClass="mb-1"
                          fetch_onload
                          className=""
                          message={errors.items?.[i]?.item?.message}
                          label=""
                          onChange={(value, option) => {
                            field.onChange(value);
                            setValue(`items.${i}.rate`, option.selling_price);
                            calcTotal(i);
                          }}
                        />

                      )}
                    />
                  </div>

                  <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                    <UiInput
                      name={`items.${i}.qty`}
                      {...register(`items.${i}.qty`, { onChange: (e) => { calcTotal(i); } })}
                      parentClass="mb-0"
                      message={errors.items?.[i]?.qty?.message}
                      noerror={true}
                      title={errors.items?.[i]?.qty?.message}

                    />
                  </div>
                  <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                    <UiInput
                      name={`items.${i}.rate`}
                      {...register(`items.${i}.rate`, { onChange: (e) => calcTotal(i) })}
                      parentClass="mb-0"
                      message={errors.items?.[i]?.rate?.message}
                      noerror={true}
                      title={errors.items?.[i]?.rate?.message}
                    />
                  </div>

                  <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                    <UiSelect
                      name={`items.${i}.tax`}
                      {...register(`items.${i}.tax`, { onChange: (e) => calcTotal(i) })}
                      parentClass="mb-0"
                      message={errors.items?.[i]?.tax?.message}
                      noerror={true}
                      options={[0, 5, 12, 18, 28]}
                    />
                    <UiInput
                      name={`items.${i}.tax_amount`}
                      {...register(`items.${i}.tax_amount`)}
                      type="hidden"
                    />
                  </div>
                  <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                    <UiInput
                      name={`items.${i}.amount`}
                      {...register(`items.${i}.amount`, { onChange: (e) => calcTotal() })}
                      parentClass="mb-0"
                      message={errors.items?.[i]?.amount?.message}
                      noerror={true}
                      title={errors.items?.[i]?.amount?.message}
                    />
                  </div>

                  <div className="col1 border border-end-0 text-center p-1" style={{ width: '35px' }}>
                    <UiButton className="btn btn-outline-danger" onClick={() => remove(i)} icon="delete"> </UiButton>
                  </div>
                </SortableItem>
              ))}
            </SortableContainer>

            <div className="d-flex pitable bg-white" style={{ minWidth: '700px' }} >
              <div className={`col1  border-end-0 border-start-0`} style={{ width: '50px' }}>
              </div>
              <div className="col  border-end-0 p-1" style={{ minWidth: '200px' }}>

              </div>
              <div className="col1  border-end-0 p-1" style={{ width: '110px' }}>
              </div>
              <div className="col1  border-end-0 p-1" style={{ width: '110px' }}>
              </div>
              <div className="col1  border-end-0 p-1" style={{ width: '110px' }}>
                Total
              </div>
              <div className="col1 border  p-1" style={{ width: '110px' }}>
                {state.grandtotal}
              </div>


              <div className="col1  border-end-0 text-center p-1" style={{ width: '35px' }}>
              </div>
            </div>
            </div>




            <div className="text-center mt-3">
              <UiButton className="btn btn-light" onClick={() => insertEntry()} title="Add Item" icon="add"> </UiButton>
            </div>


          </BootstrapModal.Body>
          <BootstrapModal.Footer className='justify-content-start'>
            <form id="jvform" onSubmit={handleSubmit(onSubmitHandler)}>
              <input type="hidden" value={id} name="id" {...register("id")} />
              <input type="hidden" value={type} name="type" {...register("type")} />
              <UiButton className="btn btn-primary" type="submit" disabled={fields.length == 0} title="Save"/>
               
            </form>
          </BootstrapModal.Footer>
        </> : <BgLoader />}
    </BootstrapModal>
  );
});

export default ItemGroup;
